import { ProductCategory } from '../../../models/product/dto/product.dto';

/**
 * Maps product categories to Chakra color schemes.
 */
export const CATEGORY_COLORS: Record<ProductCategory, string> = {
  [ProductCategory.EQUIPMENT]: 'blue',
  [ProductCategory.BEVERAGES]: 'green',
  [ProductCategory.FOOD]: 'orange',
  [ProductCategory.ACCESSORIES]: 'purple',
  [ProductCategory.APPAREL]: 'pink',
};

/**
 * Returns the color scheme for a product category.
 */
export function getCategoryColor(category: ProductCategory): string {
  return CATEGORY_COLORS[category] || 'gray';
}

/**
 * Returns the stock badge color based on stock quantity and unlimited flag.
 */
export function getStockColorScheme(stock: number, hasUnlimitedStock: boolean): string {
  if (hasUnlimitedStock) return 'green';
  if (stock > 0) return 'blue';
  return 'red';
}

/**
 * Returns a display label for stock quantity.
 */
export function getStockLabel(stock: number, hasUnlimitedStock: boolean): 'unlimited' | 'out_of_stock' | number {
  if (hasUnlimitedStock) return 'unlimited';
  if (stock === 0) return 'out_of_stock';
  return stock;
}

/**
 * Formats a price using Intl.NumberFormat.
 */
export function formatProductPrice(price: number, currency: string): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
  }).format(price);
}
